import { NgModule } from '@angular/core';
import { CustomMaterialModule } from '@sk/custom-material';
import { CommonModule } from '@angular/common';
import { AlertDialogComponent } from 'shared/dialogs/alert-dialog/alert-dialog.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [AlertDialogComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FlexLayoutModule
  ],
  providers: [],
  exports: [AlertDialogComponent]
})
export class AlertDialogModule {
}
